import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

export function* markDocumentReadCarltonForest({ payload }) {
  yield put(actions.setCarltonForestReadingLoading(true));
  try {
    yield call(Api.markDocumentRead, {
      document_read: payload,
      carltonForest: true,
    });
    yield put(actions.setCarltonForestReadingLoading(false));
  } catch (error) {
    yield put(actions.addError("Reading List Carlton Forest", error));
    yield put(actions.setCarltonForestReadingLoading(false));
  }
}

export function* submitCarltonForestFormSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.submitCarltonForestForm, formName, formContent);
  } catch (error) {
    yield put(
      actions.addError("Post Induction form Carlton Forest error", error)
    );
  }
}
export function* postCarltonForestFormSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.postCarltonForestForm, formName, formContent);
  } catch (error) {
    yield put(
      actions.addError("Post Induction form item Carlton Forest error", error)
    );
  }
}

export function* postSSOWCarltonForest({ payload }) {
  try {
    yield put(
      actions.setSSOWCarltonForestLoading(Object.keys(payload.formContent)[0])
    );
    yield put(actions.setSSOWItemsCarltonForestLoading(true));
    const { formName, formContent } = payload;
    yield call(Api.postSSOWCarltonForest, formName, formContent);
    yield put(actions.setSSOWCarltonForestLoading(""));
    yield put(actions.setSSOWItemsCarltonForestLoading(false));
  } catch (error) {
    yield put(actions.addError("Post SSOW Carlton Forest error", error));
    yield put(actions.setSSOWCarltonForestLoading(""));
    yield put(actions.setSSOWItemsCarltonForestLoading(false));
  }
}
